import { Stack, styled, Typography, useTheme } from '@mui/material';
import { css } from '@mui/system';
import { CaretRightIcon } from '@phosphor-icons/react';
import type { LinkProps } from '@tanstack/react-router';
import { Link } from '@tanstack/react-router';
import type { ElementType } from 'react';

import CarIcon from '@/assets/icons/car.svg?react';
import ParkAndRideFacilityIcon from '@/assets/icons/map-markers/facilities/park-and-ride-facility.svg?react';
import { StatNumber } from '@/components/common/StatNumber';
import type { ParkAndRideFacility, ParkAndRideFacilityData } from '@/modules/api/backend';
import { FeatureType } from '@/types/FeatureType';

const StyledTypography = styled(Typography)(
  ({ theme }) => css`
    text-decoration: none;
    cursor: pointer;
    color: ${theme.palette.text.primary};
    &:hover {
      text-decoration: none;
    }
  `,
);

interface ParkAndRideFacilityListProps {
  facility: ParkAndRideFacility;
  data?: ParkAndRideFacilityData;
}

export function StationParkAndRideFacilityListItem({ facility, data }: ParkAndRideFacilityListProps) {
  const theme = useTheme();
  const { id, name, numParkingSpaceTotal } = facility;

  return (
    <Stack
      component={Link as ElementType<LinkProps>}
      direction="row"
      gap={1}
      px={2}
      search={{ type: FeatureType.PARK_AND_RIDE_FACILITY, id }}
      style={{ textDecoration: 'none' }}
      to="/"
    >
      <Stack alignItems="center" direction="row" spacing={1} width={120}>
        <CarIcon />
        <StatNumber sx={{ color: theme.palette.text.primary }}>
          {data?.numVacantSpaces ?? numParkingSpaceTotal ?? '?'}
        </StatNumber>
      </Stack>
      <Stack alignItems="center" direction="row" gap={2} justifyContent="space-between" sx={{ flex: 1, minWidth: 0 }}>
        <ParkAndRideFacilityIcon />
        <StyledTypography sx={{ flex: 1 }}>{name || 'Keine Angabe'}</StyledTypography>
        <CaretRightIcon color={theme.palette.text.secondary} size={24} />
      </Stack>
    </Stack>
  );
}
